/**
 * Application Entry Point
 * 
 * Initializes the React application and mounts it to the DOM
 * 
 * Process:
 * 1. Imports React and ReactDOM for application initialization
 * 2. Imports global CSS styles (index.css)
 * 3. Imports the root App component
 * 4. Creates a React root from the "root" DOM element (defined in public/index.html)
 * 5. Renders the App component into the root element
 * 
 * The #root element is defined in public/index.html:
 * <div id="root"></div>
 * 
 * Architecture:
 * - React 18+ uses createRoot() API for concurrent features
 * - StrictMode not used, but could be added for development warnings
 * - All application logic is contained in App.js and its children
 * 
 * Dependencies:
 * - React: Core UI library
 * - ReactDOM: DOM rendering library
 * - ./index.css: Global application styles
 * - ./App: Root application component
 * 
 * Usage:
 * This file is the entry point specified in webpack/build configuration
 * It should not be modified for adding routes or features
 * All routing and feature logic belongs in App.js and its children
 * 
 * @example
 * // Development server automatically loads this entry point
 * // No manual invocation needed
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';  // Import global CSS styles
import App from './App';  // Import root App component with routing

// Create a root element from the DOM node with id="root" (defined in public/index.html)
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the App component into the root element
// All application routes and components are defined within App.js
root.render(
    <App />
);
